var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-wrap"},_vm._l((_vm.widgets),function(w,i){return _c('Widget',{key:_vm.name + ':' + i,staticClass:"my-5",style:({ width: _vm.$vuetify.breakpoint.mdAndUp ? w.width || '50%' : '100%' }),attrs:{"w":w}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }